import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'

Vue.config.productionTip = false
if ('serviceWorker' in navigator) {
    window.addEventListener('load', function () {
        navigator.serviceWorker.register('/sw.js').then(function (registration) {
            console.log('Service worker successfully registered on scope', registration.scope);
              registration.onupdatefound = function() {
                if (navigator.serviceWorker.controller) {
            // The updatefound event implies that registration.installing is set
            var installingWorker = registration.installing;
            installingWorker.onstatechange = function() {
              console.log(installingWorker.state)
            }
          } else {
            console.log('ici')
            window.location.refresh
          }
              }
        }).catch(function (error) {
            console.log('Service worker failed to register');
        });
    });
}
new Vue({
  render: h => h(App),
}).$mount('#app')
